<template>
    <div ref="adminTabItems" v-if="auth.is_admin" class="tab-items mt-4">
        <div class="divider sm mb-4"></div>
        <div class="row">
            <div class="mb-3 col-12 col-lg-6">
                <label for="minCalc" class="form-label">Minimum Question Answered to Calculate Stats</label>
                <input type="number" v-model="variables.min_questions_answered_stats_calculate" class="form-control form-control-lg" id="minCalc" placeholder="Minimum Question Answered to Calculate Stats in case of inomplete Survey" min="1">
            </div>
            <div class="mb-3 col-12 col-lg-6">
                <label for="minDel" class="form-label">Minimum Question Answered to Avoid Auto Deletion</label>
                <input type="number" v-model="variables.min_questions_answered_avoid_auto_deletion" class="form-control form-control-lg" id="minDel" placeholder="Minimum Question Answered to Avoid Auto Deletion" min="1">
            </div>
	        <div class="mb-3 col-12 col-lg-6">
		        <label for="minDel" class="form-label">Anonymous Survey Question Count</label>
		        <input type="number" v-model="variables.anonymous_survey_question_count" class="form-control form-control-lg" id="anonymousCount" placeholder="Number of Question to be Generated for Anonymous Survey" min="3">
	        </div>
	        <div class="mb-3 col-12 col-lg-6">
		        <label for="minDel" class="form-label">Normal Survey Question Count</label>
		        <input type="number" v-model="variables.normal_survey_question_count" class="form-control form-control-lg" id="normalCount" placeholder="Number of Question to be Generated for Normal Survey" min="3">
	        </div>
            <div class="mb-3 col">
                <button type="button" class="btn btn-dark rounded-pill float-end" v-ripple @click="update_variables">Save Changes</button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useAuthStore } from "@/stores/auth-store";
import apiClient from '@/utils/axios';
import { useHttpErrorManager } from '@/composables/useHttpErrorManager';
import { useAppHelpers } from '@/composables/useAppHelpers';

const auth = useAuthStore();
const helper = useAppHelpers();

const variables = ref({
    min_questions_answered_avoid_auto_deletion: 3,
    min_questions_answered_stats_calculate: 8,
	anonymous_survey_question_count: 10,
	normal_survey_question_count: 50
});

const adminTabItems = ref(null);

const fetch_variables = async () => {
    const url = `/admin/fetch/variables`;
    try {
        const response = await apiClient.get(url, {});
        if (response.status === 200) {
            for (let i = 0; i < Object.entries(response.data.data).length; i++) {
                variables.value[response.data.data[i].variable_name] = response.data.data[i].value;
            }
        }
        helper.loaderOff(adminTabItems.value);
    } catch (error) {
        let errorObj = await useHttpErrorManager().handleError(error, false);
        helper.loaderOff(adminTabItems.value);
    }
};

onMounted(async () => {
    helper.loaderOn(adminTabItems.value);
    await fetch_variables();
});

const update_variables = async () => {
    helper.loaderOn(adminTabItems.value)
    const url = `/admin/update/variables`;
    try {
        const response = await apiClient.post(url, {
            min_questions_answered_avoid_auto_deletion: variables.value.min_questions_answered_avoid_auto_deletion,
            min_questions_answered_stats_calculate: variables.value.min_questions_answered_stats_calculate,
	        anonymous_survey_question_count: variables.value.anonymous_survey_question_count,
	        normal_survey_question_count: variables.value.normal_survey_question_count,
        });
        if (response.status === 200) {
            await fetch_variables();
        }
        else{
            helper.loaderOff(adminTabItems.value);
        }
    } catch (error) {
        let errorObj = await useHttpErrorManager().handleError(error, false);
        helper.loaderOff(adminTabItems.value);
    }
}

</script>